import * as types from './constants';

// Deactivate Code
export const deactivateCodeRequest = data => (
  { type: types.DEACTIVATE_CODE_REQUEST, payload: data }
);

export const deactivateCodeDone = data => (
  { type: types.DEACTIVATE_CODE_DONE, payload: data }
);

export const deactivateCodeFailed = errors => (
  { type: types.DEACTIVATE_CODE_FAILED, payload: errors }
);